import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "img-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "load-image d-flex a-i-center j-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "test-loading" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["src", "alt"]

import { toRefs, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageComponent',
  props: {
    src: {},
    class: {},
    description: {}
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props)
const load = ref(true)

const loadImage = () => load.value = false

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, load.value]
    ]),
    _withDirectives(_createElementVNode("img", {
      class: _normalizeClass([_unref(data)?.class?.value]),
      src: _unref(data)?.src?.value,
      alt: _unref(data)?.description?.value + 'image',
      onLoad: loadImage
    }, null, 42, _hoisted_4), [
      [_vShow, !load.value]
    ])
  ], 64))
}
}

})